import { Button, Checkbox } from 'antd'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import React from 'react'
import styles from './ControlPanel.module.scss'
import { useComponentLocale } from '../../../hooks/useComponentLocale'
import { useDispatch, useSelector } from 'react-redux'
import { selectHand } from '../../../Redux/selectors/selectors'
import { openConfirmDeleteModal } from '../../utils'
import { DeleteOutlined } from '@ant-design/icons'
import { useActions } from '../../../hooks/useActions'
import { getAssistanceByData } from '../../../Redux/_actions/asyncActions/Trainer/get_assistance_by_data'

function ControlPanel({
	isRangeMode,
	toggleRangeMode,
	isHideOOPHand,
	toggleHideOOPHand,
	displayHH,
	onRemoveSingleHand,
	onOpenRaw,
	source,
	handData,
	heroPerspective,
}) {
	const getLocale = useComponentLocale()
	const gtoRangeLocale = getLocale({ component: 'hand_result', section: 'gto_range' })
	const hideOopLocale = getLocale({ component: 'hand_result', section: 'hide_oop' })
	const removeHandLocale = getLocale({ component: 'hands', section: 'remove_hand' })
	const confirmRemoveLocale = getLocale({ component: 'hands', section: 'confirm_remove' })
	const cancelLocale = getLocale({ component: 'common_buttons', section: 'cancel' })

	const { selectedRowIndex } = useSelector(selectHand)
	const dispatch = useDispatch()
	const { setIsOpenAIAnalyzeModal, setHandData } = useActions()

	const checkboxes = [
		{ checked: isRangeMode, text: gtoRangeLocale, handleChange: toggleRangeMode },
		{ checked: isHideOOPHand, text: hideOopLocale, handleChange: toggleHideOOPHand },
	]

	let isDrawGPTButton = false

	try {
		if (heroPerspective) {
			handData.result.trace.forEach((node) => {
				if (handData.isHero[node.player] && !isDrawGPTButton) {
					const indexAction = node.choose
					isDrawGPTButton = node.actions_played[indexAction] < 0.021
				}
			})
		}
	} catch (error) {
		console.log(error)
	}

	const onAIAnalysis = () => {
		const source = window.location.pathname.split('/')[1]

		const players = handData.positions.map((position, index) => ({
			position,
			hero: handData.isHero[index],
			cards: handData.hands[index],
			startingNormStack: handData.stacks[index],
		}))


		setIsOpenAIAnalyzeModal(true)
		setHandData(handData)
	}

	return (
		<div className={styles.controlPanel}>
			<div>
				{checkboxes.map(({ checked, text, handleChange }) => (
					<Checkbox checked={checked} size='small' onChange={(e) => handleChange(e)} key={text}>
						{text}
					</Checkbox>
				))}
			</div>

			<div>
				{displayHH && (
					<Button
						icon={<DeleteOutlined />}
						type='link'
						onClick={() =>
							openConfirmDeleteModal(
								selectedRowIndex,
								onRemoveSingleHand,
								removeHandLocale,
								confirmRemoveLocale,
								cancelLocale
							)
						}
					/>
				)}

				{source === 'upload' && (
					<Button
						icon={<LegacyIcon type='file-text' />}
						style={{ display: displayHH ? 'auto' : 'none' }}
						onClick={onOpenRaw}
						shape='round'
						type='link'
					>
						HH
					</Button>
				)}

				{isDrawGPTButton && (
					<Button size='small' onClick={onAIAnalysis}>
						GPT Coach
					</Button>
				)}
			</div>
		</div>
	)
}

export default ControlPanel
